import React from 'react';
import {Radio, Button,  Form, message, Input } from 'antd';
import api from "utils/api";
import utils from "utils";
import Loader from "Components/Loader";
import {  ArrowRightOutlined } from '@ant-design/icons'
import SubmitButton from "../Patient/SubmitButton"
import { CONSTANTS } from 'utils/constant';
class DotScreening extends React.Component {
    constructor(props) {
        super(props)
        let { appointment_id } = this.props.data || {};
        this.state={appointment_id,
        allow_submit:false,
        buttonLoading: true
    }
        this.form=React.createRef()
    }
    componentDidMount() {
        this.props.formAction(false)
        this.getDotFactorData()
    }

    getDotFactorData() {
        api.get_dot_questions()
            .then(res => {
                let { status, data: { results } } = res.data || {}
             
                if (status == 200) {
                    let data = results && results[0]
                    this.setState({
                        question_data:data,
                        isLoading: false,
                        buttonLoading: false
                    },()=>{
                        this.getPFConsultationData()
                    })
                   
                }
            })
    }
    getPFConsultationData(){
        let data = {
            app_id: this.state.appointment_id,
            type: "dot",
        }
        api.get_consultation_details(data)
            .then((response) => {
                let tempData={}
                Object.entries(response.data.data?.results?.dot[0]).forEach(([key,item])=>{
                    if(typeof(item)==='object'){
                        if(!tempData.hasOwnProperty(key)){tempData[key]=""}
                            tempData[key]=item.comments
                    }
                })
                   if(response.data.data?.results?.dot[0].is_completed && (! this.state.is_Dot_form_update))
                   {
                    this.setState({is_Dot_form_update:true})
                   }
                    this.form.current?.setFieldsValue(tempData);
            })
            .catch(() => {

            })
    }

    onSubmit(userInputs) {
        this.setState({buttonLoading: true})
        let responseData = {...this.state.question_data}
        let allow_submit = Object.values(userInputs).some(e=> e)
        this.setState({allow_submit:allow_submit})
        Object.entries(this.state.question_data.values).map(([groupItemKey,groupItemValue])=>{
            responseData.values[groupItemKey].comments=userInputs[groupItemKey]
        })
    if(this.state.allow_submit){
        api.submit_dot({...responseData, app_id: this.state.appointment_id, is_completed: true,key:"dot",type:this.props.data.user_type || 'adult' })
            .then(res => {
                this.setState({ is_Dot_form_update: true})
                if (res.data?.status == 200) {
                    message.success(res.data?.message, ErrorDuration);
                    this.setState({buttonLoading: false})
                    this.props.formAction(false)
                    // this.props.setDsmDone(this.state.dsmDone)
                }
            })}else{
                message.error(`${CONSTANTS.CANNOT_SUBMIT_EMPTY}` , ErrorDuration)
                this.setState({buttonLoading: false})
                this.props.formAction(false)
            }
       
    }
    render(){
        return (
            <>
                {this.state.isLoading ? <Loader style={this.props.style || {}} /> : <>
                    <div style={this.props.style || {}} className="dsm-screening-container video-casenotes-consultation-wrapper">
                        {/* {this.state.questions && this.state.questions.length && <> */}
                        {this.state.question_data && <>
                            <div className="static-title" >
                                {/* <p className="question-title" > This screening will be an addendum to Case Sheet and the Clinician will bear in mind the following questions (need not ask) while doing the initial evaluation and he or she will click Yes in the checkbox in case the client reports a positive symptom to the relevant question. </p> */}

                                <p className="question-title" >{this.state.question_data.title}</p>
                            </div>
                            <Form
                                onFinish={this.onSubmit.bind(this)}
                                ref={this.form}
                                onFieldsChange={()=> this.props.formAction(true)}
                                colon={false}
                                labelWrap
                                labelAlign="left"
                                labelCol={{ span: 14 }}
                                wrapperCol={{ span: 10 }}
                                requiredMark={false}
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                  }}
                            >
                                {(Object.entries(this.state.question_data?.values||{})).map(([formgroupItemKey,formgroupItemData])=>{
                                                        {  
                                                            if(formgroupItemData.values.length === 0){
                                                                return (
                                                                    <div className='group-form-item' key={formgroupItemKey}>
                                                                    <Form.Item 
                                                                        name={[formgroupItemKey]}
                                                                        label={<div style={{display:"flex",flexDirection:"column"}}><div style={{fontWeight:"bold"}}>{formgroupItemData.title}</div><div><ul>{formgroupItemData?.notes.split("\n").map((val,i)=>{if(val.trim()) return <li key={i}> {utils.ConvertToPascalCase(val.trim())} </li>})}</ul></div></div>}
                                                                        className="input-form-item"
                                                                        style={{height:"auto"}}
                                                                    >
                                                                        <Input.TextArea
                                                                            row={2}
                                                                        />
                                                                    </Form.Item>
                                                                    </div>
                                                                )
                                                            } 
                                                            else {
                                                                return (
                                                                    <div className='group-form-item' key={formgroupItemKey}>
                                                                    <Form.Item
                                                                        name={[formgroupItemKey]}
                                                                        label={utils.ConvertToPascalCase(formgroupItemData?.label)}
                                                                        className="radio-form-item"
                                                                    >
                                                                        <Radio.Group options={formgroupItemData?.values?.map((option) => {
                                                                                return {
                                                                                    label: option.selected_value,
                                                                                    value: option.selected_value
                                                                                }
                                                                            }
                                                                            )} 
                                                                        />
                                                                    </Form.Item>
                                                                    </div>
                                                                )
                                                            }
                                                        }
                                                    }      
                                    )
                                }
                            </Form>
                            <div className="submit-button-wrapper">
                                <SubmitButton label={this.state.is_Dot_form_update ?`${CONSTANTS.UPDATE}`:`${CONSTANTS.SUBMIT}`} onClick={e => this.form.current?.submit()} className={'common-btn'} loading={this.state.buttonLoading}/>
                                {/* <Button   className='common-btn' onClick={e => this.form.current?.submit()}>{this.state.is_Dot_form_update ?`${CONSTANTS.UPDATE}`:`${CONSTANTS.SUBMIT}`}<ArrowRightOutlined /></Button> */}
                            </div>
                        </> || null}
                    </div>
                </>}
            </>
        )
    }
}

export default DotScreening;